/*
 * @Author: FengXiao
 * @Date: 2020-07-02 15:19:31
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-01 00:47:43
 */
import Cookies from 'js-cookie';
// import requestApi from '@/service';

export default {
  initScrollTop() {
    window.scrollTo(0, 0);
  },
  refreshCurrentPage() {
    this.$router.go(0);
  },
  // 截流
  _riverClosure(name, time) {
    const key = `${key}RiverClosure`;
    if (this[key]) return false;
    this[key] = setTimeout(() => {
      this[key] = null;
    }, time);
    return true;
  },
  // 防抖
  _debounce(cb, key, time) {
    if (this[`Debounce-${key}`]) {
      clearTimeout(this[`Debounce-${key}`]);
    }
    this[`Debounce-${key}`] = setTimeout(() => {
      this[`Debounce-${key}`] = null;
      cb && cb();
    }, time);
  },
  checkLogin() {
    if (!Cookies.get('token')) {
      this.gotoLogin();
      return false;
    }
    return true;
  },
  gotoLogin() {
    this.$router.push('/login');
  },
};
